import actionCreator from '../../../utils/actionCreator';

const clientActionTypes = ['OPEN_TOAST', 'CLOSE_TOAST'];

export const { types: toastTypes, actions: toastActions } = actionCreator(clientActionTypes);
